export const REALTIME_CONNECTION_STATES = {
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  RECONNECTING: "reconnecting",
  ERROR: "error",
} as const;

export const REALTIME_CONNECTION_ACTIONS = {
  RESET: "reset",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  MESSAGE_RECEIVED: "messageReceived",
  RECONNECTING: "reconnecting",
  DISCONNECTED: "disconnected",
  ERROR: "error",
} as const;

export const REALTIME_CONNECTION_ERROR_MESSAGES = {
  PARSE_MESSAGE: "Failed to parse message",
  CONNECTION: "Connection error",
  SUBSCRIPTION: "Subscription error",
  CONNECTION_FAILED: "Connection failed",
} as const;

export const CENTRIFUGE_EVENTS = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  ERROR: "error",
} as const;

export const CENTRIFUGE_SUBSCRIPTION_EVENTS = {
  PUBLICATION: "publication",
  ERROR: "error",
} as const;
